export const mask = {
  methods: {
    maskSINOrSSN(value) {
      if (!value) return '';
      const masked = '*'.repeat(value.length - 3) + value.slice(value.length - 3);
      return value[0] === '9' ? value[0] + masked.slice(1) : masked;
    },
    maskHSTOrGSTOrQST(value) {
      if (!value) return '';

      const firstMatch = value.match(/[0-9]+/)[0];
      if (!value.match(/[a-zA-Z]/i)) return null;
      return (
        '*'.repeat(firstMatch.length - 3) +
        firstMatch.slice(firstMatch.length - 3) +
        value.slice(value.match(/[a-zA-Z]/i)['index'])
      );
    }
  }
};
